import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'real-estate-investment-amount',
    templateUrl: './real-estate-investment-amount.component.html',
    styleUrls: ['./real-estate-investment-amount.component.scss'],
    standalone: false
})
export class RealEstateInvestmentAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  //PLEINE_PROPRIETE_CREDIT
  isPleineProprieteCredit = false;

  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const { parameters } = this.subscriptionFacade?.getPledge() || {};
    this.isPleineProprieteCredit =
      parameters?.realEstateOwnershipType === 'PLEINE_PROPRIETE_CREDIT';
    this.subscriptionFacade.initForm(this, { ...parameters });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
